import React, { Component } from 'react'
import { APIURL } from '../../config/config'
import axios from 'axios'
import { AlertSuccess, AlertError } from '../Alert/Alert'
import Switch from 'react-switch'
import Swal from 'sweetalert2'
import { connect } from "react-redux"

class DebtStatusSetting extends Component {
  constructor(props) {
    super(props)

    this.state = {
      actionType: "บันทึก",
      debt_status_list: [],
      debt_status_id: '',
      debt_status: '',
      debt_status_name: '',
      debt_status_color: 'badge badge-primary',
      sort_order: 1,
      require_admin: 0,
      user: {},
      isLoading: false,
    }

    this.loadDebtStatusData = this.loadDebtStatusData.bind(this)
    this.saveDebtStatus = this.saveDebtStatus.bind(this)
    this.setEditForm = this.setEditForm.bind(this)
    this.clearForm = this.clearForm.bind(this)
    this.onChangeSwitch = this.onChangeSwitch.bind(this)
    this.deleteDebtStatus = this.deleteDebtStatus.bind(this)
  }

  loadDebtStatusData() {
    this.setState({ isLoading: true })
    let url = APIURL + '/debt_status/all?user_type=' + this.state.user.type
    axios.get(url).then(res => {
      this.setState({
        debt_status_list: res.data,
        isLoading: false
      })
    }).catch(err => {
      console.error('Error loading debt status:', err)
      this.setState({ isLoading: false })
    })
  }

  deleteDebtStatus(debt_status) {
    let debt_status_id = debt_status.debt_status_id
    let debt_status_name = debt_status.debt_status_name

    Swal.fire({
      title: 'ยืนยันการลบ ' + debt_status_name + ' ?',
      text: 'ข้อมูลจะถูกทำเครื่องหมายลบ (soft delete)',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'ลบ',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        let url = APIURL + '/debt_status/' + debt_status_id
        axios.delete(url).then(res => {
          if (res.data.success) {
            AlertSuccess('ลบข้อมูลแล้ว')
            this.loadDebtStatusData()
          } else {
            AlertError('ไม่สามารถลบได้')
          }
        }).catch(err => {
          AlertError('เกิดข้อผิดพลาด')
        })
      }
    })
  }

  saveDebtStatus() {
    let actionType = this.state.actionType
    let debt_status = this.state.debt_status.trim()
    let debt_status_name = this.state.debt_status_name.trim()
    let debt_status_color = this.state.debt_status_color
    let sort_order = this.state.sort_order
    let require_admin = this.state.require_admin

    // Validation
    if (!debt_status) {
      AlertError('กรุณาระบุค่าสถานะหนี้ (ภาษาอังกฤษ)')
      return
    }
    if (!debt_status_name) {
      AlertError('กรุณาระบุชื่อสถานะหนี้')
      return
    }

    let data = {
      debt_status,
      debt_status_name,
      debt_status_color,
      sort_order,
      require_admin,
      user_created: this.state.user.user,
      user_updated: this.state.user.user
    }

    this.setState({ isLoading: true })

    if (actionType === "บันทึก") {
      let url = APIURL + '/debt_status'
      axios.post(url, data).then(res => {
        this.setState({ isLoading: false })
        if (res.data.success) {
          AlertSuccess('บันทึกข้อมูลแล้ว')
          this.clearForm()
          this.loadDebtStatusData()
        } else {
          AlertError('ไม่สามารถบันทึกได้')
        }
      }).catch(err => {
        this.setState({ isLoading: false })
        AlertError('เกิดข้อผิดพลาด')
      })
    } else if (actionType === "แก้ไข") {
      let debt_status_id = this.state.debt_status_id
      let url = APIURL + '/debt_status/' + debt_status_id
      axios.put(url, data).then(res => {
        this.setState({ isLoading: false })
        if (res.data.success) {
          AlertSuccess('แก้ไขข้อมูลแล้ว')
          this.clearForm()
          this.loadDebtStatusData()
        } else {
          AlertError('ไม่สามารถแก้ไขได้')
        }
      }).catch(err => {
        this.setState({ isLoading: false })
        AlertError('เกิดข้อผิดพลาด')
      })
    }
  }

  setEditForm(debt_status) {
    this.setState({
      actionType: 'แก้ไข',
      debt_status: debt_status.debt_status,
      debt_status_name: debt_status.debt_status_name,
      debt_status_color: debt_status.debt_status_color || 'badge badge-primary',
      sort_order: debt_status.sort_order,
      require_admin: debt_status.require_admin,
      debt_status_id: debt_status.debt_status_id,
    })
  }

  clearForm() {
    this.setState({
      actionType: "บันทึก",
      debt_status: '',
      debt_status_name: '',
      debt_status_color: 'badge badge-primary',
      sort_order: this.state.debt_status_list.length + 1,
      require_admin: 0,
      debt_status_id: '',
    })
  }

  onChangeSwitch(checked, debt_status) {
    let item_update = debt_status
    let debt_statuses = this.state.debt_status_list
    let item_index = this.state.debt_status_list.findIndex(data => data.debt_status_id === debt_status.debt_status_id)

    let newStatus = checked ? 'show' : 'hidden'
    let url = checked ? APIURL + '/debt_status/' + debt_status.debt_status_id + '/show'
      : APIURL + '/debt_status/' + debt_status.debt_status_id + '/hide'

    axios.put(url).then(res => {
      if (res.data.success) {
        item_update.status_field = newStatus
        debt_statuses[item_index] = item_update
        this.setState({
          debt_status_list: debt_statuses
        })
      }
    }).catch(err => {
      AlertError('ไม่สามารถเปลี่ยนสถานะได้')
    })
  }

  componentWillMount() {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  componentDidMount() {
    this.loadDebtStatusData()
  }

  getBadgeColorPreview(colorClass) {
    return colorClass
  }

  render() {
    const colorOptions = [
      { value: 'badge badge-primary', label: 'Primary (สีน้ำเงิน)', preview: 'badge badge-primary' },
      { value: 'badge badge-success', label: 'Success (สีเขียว)', preview: 'badge badge-success' },
      { value: 'badge badge-info', label: 'Info (สีฟ้าอ่อน)', preview: 'badge badge-info' },
      { value: 'badge badge-warning', label: 'Warning (สีเหลือง)', preview: 'badge badge-warning' },
      { value: 'badge badge-danger', label: 'Danger (สีแดง)', preview: 'badge badge-danger' },
      { value: 'badge badge-secondary', label: 'Secondary (สีเทา)', preview: 'badge badge-secondary' },
      { value: 'badge badge-dark', label: 'Dark (สีดำ)', preview: 'badge badge-dark' },
      { value: 'badge badge-light', label: 'Light (สีขาว)', preview: 'badge badge-light text-dark' },
    ]

    return (
      <div className="row">
        <div className="col-sm-7">
          <div className="card card-accent-info">
            <div className="card-header">
              <strong className="text-title">
                รายการสถานะหนี้
              </strong>
            </div>
            <div className="mr-5 mt-3 text-right"><span className="text-danger">กดปิดการใช้งาน หากไม่ต้องการแสดงรายการ</span></div>

            <div className="card-block" style={styles.overflowY}>
              <table className="table table-striped table-responsive">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center text-nowrap">ค่า</th>
                    <th className="text-center text-nowrap">ชื่อสถานะ</th>
                    <th className="text-center text-nowrap">สี</th>
                    <th className="text-center text-nowrap">Admin Only</th>
                    <th className="text-center text-nowrap">การใช้งาน</th>
                    <th className="text-center">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.debt_status_list.map((debt_status, index) => (
                    <tr key={index}>
                      <td className="text-center" style={{ width: 10 }}>{index + 1}</td>
                      <td className="text-center" style={{ width: 80 }}>{debt_status.debt_status}</td>
                      <td className="text-center" style={{ width: 100 }}>{debt_status.debt_status_name}</td>
                      <td className="text-center" style={{ width: 80 }}>
                        <span className={debt_status.debt_status_color}>
                          {(debt_status.debt_status_color || '').replace('badge ', '') || '-'}
                        </span>
                      </td>
                      <td className="text-center" style={{ width: 80 }}>
                        {debt_status.require_admin ? 'ใช่' : 'ไม่'}
                      </td>
                      <td className="text-nowrap text-center" style={{ width: 80 }}>
                        {debt_status.status_field === 'show' ? 'ใช้งาน' : 'ไม่ใช้งาน'}
                        <br />
                        <Switch height={20} width={48}
                          onChange={(checked) => this.onChangeSwitch(checked, debt_status)}
                          checked={debt_status.status_field === 'show'}
                        />
                      </td>
                      <td className="text-center" style={{ width: 120 }}>
                        <div className="d-block">
                          <button type="button"
                            className="btn btn-sm btn-warning btn-md-width mb-1 d-block"
                            onClick={() => this.setEditForm(debt_status)}
                          >
                            <i className="fa fa-edit" /> แก้ไข
                          </button>
                          <button type="button"
                            className="btn btn-sm btn-danger btn-md-width d-block"
                            onClick={() => this.deleteDebtStatus(debt_status)}
                          >
                            <i className="fa fa-remove" /> ลบ
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {this.state.debt_status_list.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-sm-5">
          <div className="card card-accent-success">
            <div className="card-header card-customer">
              <strong className="text-title">เพิ่ม/แก้ไขสถานะหนี้</strong>
            </div>

            <div className="card-block">
              <div className="form-group">
                <label htmlFor="debt_status">ค่าสถานะหนี้ (ภาษาอังกฤษ) *</label>
                <input
                  value={this.state.debt_status}
                  type="text"
                  className="form-control"
                  name="debt_status"
                  placeholder="ตัวอย่าง: normal, npl, complete"
                  style={styles.inputSearch}
                  onChange={(e) => {
                    this.setState({
                      debt_status: e.target.value.toLowerCase().replace(/\s/g, '_')
                    })
                  }}
                  disabled={this.state.actionType === "แก้ไข"}
                />
                <small className="form-text text-muted">ใช้ตัวพิมพ์เล็ก เชื่อมด้วย _ ไม่เว้นว่าง เช่น: normal, npl, request</small>
              </div>

              <div className="form-group">
                <label htmlFor="debt_status_name">ชื่อสถานะหนี้ (ภาษาไทย) *</label>
                <input
                  value={this.state.debt_status_name}
                  type="text"
                  className="form-control"
                  name="debt_status_name"
                  placeholder="ตัวอย่าง: ปกติ, หนี้เสีย"
                  style={styles.inputSearch}
                  onChange={(e) => {
                    this.setState({
                      debt_status_name: e.target.value
                    })
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="debt_status_color">สี Badge</label>
                <select
                  value={this.state.debt_status_color}
                  className="form-control"
                  name="debt_status_color"
                  onChange={(e) => {
                    this.setState({
                      debt_status_color: e.target.value
                    })
                  }}
                >
                  {colorOptions.map((color, index) => (
                    <option key={index} value={color.value}>
                      {color.label}
                    </option>
                  ))}
                </select>
                <div className="mt-2">
                  <span>Preview: </span>
                  <span className={this.state.debt_status_color}>
                    สถานะหนี้
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="sort_order">ลำดับการแสดงผล</label>
                <input
                  value={this.state.sort_order}
                  type="number"
                  className="form-control"
                  name="sort_order"
                  min="1"
                  style={styles.inputSearch}
                  onChange={(e) => {
                    this.setState({
                      sort_order: parseInt(e.target.value) || 1
                    })
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="require_admin">
                  <input
                    type="checkbox"
                    name="require_admin"
                    checked={this.state.require_admin === 1}
                    onChange={(e) => {
                      this.setState({
                        require_admin: e.target.checked ? 1 : 0
                      })
                    }}
                  />
                  &nbsp; แสดงเฉพาะ Admin เท่านั้น
                </label>
              </div>
            </div>

            <div className="card-footer text-right">
              <button type="button"
                className="btn btn-sm btn-danger mr-2"
                style={styles.button}
                onClick={() => this.clearForm()}
                disabled={this.state.isLoading}
              >
                <i className="fa fa-refresh" /> ยกเลิก
              </button>

              <button type="button"
                className={this.state.actionType === "แก้ไข" ? "btn btn-sm btn-warning" : "btn btn-sm btn-primary"}
                style={styles.button}
                onClick={() => {
                  this.saveDebtStatus()
                }}
                disabled={this.state.isLoading}
              >
                <i className={this.state.actionType === "แก้ไข" ? "fa fa-edit" : "fa fa-save"} />
                {this.state.isLoading ? ' บันทึก...' : ' ' + this.state.actionType}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

const styles = {
  button: {
    borderRadius: 5,
    height: 36,
  },
  inputSearch: {
    borderRadius: 5,
  },
  overflowY: {
    overflow: 'scroll',
  }
}

export default connect(mapStateToProps)(DebtStatusSetting)
